import React from 'react';
import { Bell } from 'lucide-react';

interface NotificationIconProps {
  count?: number;
  onClick: () => void;
}

const NotificationIcon: React.FC<NotificationIconProps> = ({ count = 0, onClick }) => {
  return (
    <button 
      onClick={onClick}
      className="relative p-2 rounded-full bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors"
      title="Notifications"
    >
      <Bell className="w-5 h-5" />
      {count > 0 && (
        <span className="absolute top-0 right-0 -mt-1 -mr-1 px-1.5 py-0.5 bg-red-500 text-white text-xs font-bold rounded-full">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
};

export default NotificationIcon; 